import { httpClientInterface } from 'app-components/utils/core';
import { getServiceUrl } from 'app-components/utils/core/interfaces/httpClientInterface';
import z from 'zod';
import { InvoiceItemSchema, type InvoiceItemType } from './invoiceItemTypes';

const RemoteInvoiceItemSchema = InvoiceItemSchema.and(z.object({ id: z.string() }));

const GetInvoiceItemsResponseSchema = z.object({
  resources: z.array(RemoteInvoiceItemSchema),
});

const PostInvoiceItemsResponseSchema = z.object({
  resource: RemoteInvoiceItemSchema,
  clientId: z.string().optional(),
  id: z.string(),
});
export type PostInvoiceItemsResponseType = z.infer<typeof PostInvoiceItemsResponseSchema>;

const PutInvoiceItemsResponseSchema = z.object({
  resource: RemoteInvoiceItemSchema,
  id: z.string(),
});
export type PutInvoiceItemsResponseType = z.infer<typeof PutInvoiceItemsResponseSchema>;

export default {
  async create(item: InvoiceItemType & { clientId: string }) {
    const requestUrl = `${getServiceUrl()}/businesses/items`;
    return PostInvoiceItemsResponseSchema.parse((await httpClientInterface.send('POST', requestUrl, item)).data);
  },
  async fetch() {
    const requestUrl = `${getServiceUrl()}/businesses/items`;
    return GetInvoiceItemsResponseSchema.parse((await httpClientInterface.send('GET', requestUrl)).data).resources;
  },
  async update(item: InvoiceItemType & { id: string }) {
    const requestUrl = `${getServiceUrl()}/businesses/items/${item.id}`;
    return PutInvoiceItemsResponseSchema.parse((await httpClientInterface.send('PUT', requestUrl, item)).data);
  },
  async delete(id: string) {
    const requestUrl = `${getServiceUrl()}/businesses/items/${id}`;
    await httpClientInterface.send('DELETE', requestUrl);
  },
} as const;
